import { UserResponseDto } from "@/Dtos/user-dto";
import * as signalR from "@microsoft/signalr";
import useAuthStore from "@Stores/AuthStore";

Object.defineProperty(WebSocket, "OPEN", { value: 1 });

let signalRConnection: signalR.HubConnection;

async function start() {
    try {
        const { isAuthorized, auth } = useAuthStore.getState();

        signalRConnection = new signalR.HubConnectionBuilder()
            .withUrl(`${import.meta.env.VITE_APP_API_URL}Connections`, {
                accessTokenFactory: () =>
                    isAuthorized && auth ? auth?.accessToken : "",
                withCredentials: true,
            }) // Replace with your SignalR endpoint URL
            .withAutomaticReconnect()
            .configureLogging(signalR.LogLevel.Information)
            .withStatefulReconnect()
            .build();

        switch (signalRConnection.state) {
            case signalR.HubConnectionState.Disconnected:
            case signalR.HubConnectionState.Disconnecting:
                await signalRConnection.start();
                break;

            default:
                null;
        }
    } catch (err) {
        console.log(err);
        setTimeout(start, 5000);
    }

    signalRConnection.on("Connection", (data) => {
        console.log("Connected to SignalR server, ", data);
    });

    signalRConnection.invoke("Connection", "Hello");

    signalRConnection.onclose(() => {
        console.log("On Close SignalR server");
    });

    signalRConnection.on("Connection", (data) => {
        console.log(data);
    });

    signalRConnection.on("AuthUpdate", (data: UserResponseDto) => {
        console.log(data);
        // Do something with the data
    });

    signalRConnection.on("UserUpdate", (data: UserResponseDto) => {
        console.log("UserUpdate ", data);

        const { updateUser } = useAuthStore.getState();

        updateUser(data);

        // window.location.reload();
    });

    // signalRConnection.on("RoleUpdate", (data: RoleResponseDto) => {
    //     // const { updateRole } = useAuthStore.getState();

    //     console.log("Role Before", data);

    //     // Remove duplicate permissions
    //     if (data.permissions) {
    //         data.permissions = Array.from(new Set(data.permissions));
    //     }

    //     console.log("Role ", data);
    //     // get the Type if is RoleResponseDto, then update the data

    //     // if ((updateRole as RoleResponseDTo).id === data.id) {
    //     updateRole(data);
    //     // }

    //     // window.location.reload(false);
    //     // window.location.reload();

    //     // Do something with the data
    // });
}

start();

export default signalRConnection!;
